// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { offcanvas } from "./modules/_offcanvas.mjs";
import { headerscroll } from "./modules/_header.mjs";
import { actueelSlider } from "./modules/_carousels.mjs";
//import { Websearch } from "./modules/_search.mjs";

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    offcanvas();
    headerscroll();
    actueelSlider();

    const disclosure = new Disclosure();
    //const websearch = new Websearch();


    const searchUrl = 'https://ketenveiligheid.org.test/search/';
    let searchInputField = document.getElementById('search-input');

    //document.getElementById('search-button').addEventListener('click', getSearchResultsData);

    const searchInputKeyUp = (execFunction, delay) => {
        console.log('test');
        let timer;
        return function () {
            clearTimeout(timer);

            timer = setTimeout(() => {
                execFunction();
            }, delay);
        };
    };

    searchInputField.addEventListener('keyup', searchInputKeyUp(getSearchResultsData, 1000));

    function getSearchResultsData()
    {
        let searchInput = searchInputField.value;

        document.getElementById('search-results').innerHTML = '';

        if (searchInput !== '') {
            let req = new XMLHttpRequest();
            req.open('GET', searchUrl + searchInput, true);
            req.onload = function () {
                if (this.status == 200) {
                    if (typeof this.response != "undefined") {
                        let results = JSON.parse(this.response);
                        for (let i = 0; i < results.length; i++) {
                            if (typeof results[i].page_decription != 'string') {
                                results[i].page_decription = '';
                            }
                            document.getElementById('search-results').innerHTML += '<a href="' + results[i].page_url + '">' + results[i].page_title + '</a><br/><small>' + results[i].page_decription + '</small><hr/>';
                        }
                    }
                }
            }

            req.send();
        }
    }

});



